export const getCacheBypassParam = () => {
  const now = new Date()
  const minutes = now.getMinutes()
  const seconds = now.getSeconds()
  const value = ((minutes * 60 + seconds) % 120) / 4

  return Math.floor(value)
}
